import {
    GET_ALL_FILES,
    DOWNLOAD_FILE,
    GET_FILES_BY_IDS,
    GET_CURRENT_CONTENT,
    DELETE_FILES_BY_IDS
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    files: {},
    currentContent: {}
};

// REDUCER
export const FileDownloadReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_FILES: {

            const incomingFiles = action.payload;
            const files = {};

            incomingFiles.forEach(file => {
                files[file.id] = file;
            });

            return {
                ...state,
                files
            };
        }

        case GET_FILES_BY_IDS: {

            const incomingFiles = action.payload;
            const files = Object.assign({}, state.files);

            incomingFiles.forEach(file => {
                files[file.id] = file;
            });

            return {
                ...state,
                files
            };
        }

        case DELETE_FILES_BY_IDS: {
            const files = Object.assign({}, state.files)
            const ids = action.payload;

            if (ids != null) {
                ids.forEach((id) => {
                    delete files[id]
                })
            }

            return {
                ...state,
                files: files
            }
        }

        case GET_CURRENT_CONTENT: {
            const incomingFiles = action.payload;
            var newCurrentContent = {};

            if (incomingFiles?.length > 0) {
                newCurrentContent = incomingFiles[0];
            }

            return {
                ...state,
                currentContent: newCurrentContent
            }

        }

        // case DOWNLOAD_FILE: {

        //     const files = Object.assign({}, state.files);

        //     Object.values(files).forEach(file => {
        //         if (action.payload.id === file.id) {
        //             files[file.id].imageUrl = action.payload.imageUrl;
        //         }
        //     })

        //     return {
        //         ...initialState,
        //         files
        //     }
        // }
        default:
            return state;
    }
};